import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'

import GoogleImage from '@/assets/images/commuity-google.svg?react'
import { Button, Trans } from '@/components'

export enum OauthType {
  Google,
}

export default function useOauth() {
  const [oauthCode, setOauthCode] = useState<string | undefined>()
  const [oauthType, setOauthType] = useState<OauthType | undefined>()

  const hasGoogleScope = (scope: string) => {
    const googleApiScopeRegex = /www\.googleapis\.com/
    return googleApiScopeRegex.test(scope)
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    const scope = urlParams.get('scope')

    if (code && scope) {
      setOauthCode(code)
      if (hasGoogleScope(scope)) {
        setOauthType(OauthType.Google)
      }
    } else {
      setOauthCode(undefined)
    }
  }, [])

  interface GoogleButtonProps {
    loading?: boolean
    inviterCode?: string
  }

  const GoogleLoginButton = ({ loading, inviterCode }: GoogleButtonProps) => {
    return (
      <Button
        block
        type="outline"
        className="flex items-center justify-center gap-2"
        disabled={loading}
        onClick={() => {
          Cookies.set('inviter_code', inviterCode || '')
          location.href = `/api/oauth_user?oauth_type=google&purpose_type=login`
        }}
      >
        <GoogleImage className="w-6 h-6" />
        <Trans i18nKey="register.google">Continue with Google</Trans>
      </Button>
    )
  }

  const GoogleRegisterButton = ({ loading, inviterCode }: GoogleButtonProps) => {
    return (
      <Button
        block
        type="outline"
        className="flex items-center justify-center gap-2"
        disabled={loading}
        onClick={() => {
          Cookies.set('inviter_code', inviterCode || '')
          location.href = `/api/oauth_user?oauth_type=google&purpose_type=register`
        }}
      >
        <GoogleImage className="w-6 h-6" />
        <Trans i18nKey="register.google">Continue with Google</Trans>
      </Button>
    )
  }

  return {
    oauthCode,
    oauthType,
    hasGoogleScope,
    GoogleLoginButton,
    GoogleRegisterButton,
  }
}
